import React from 'react';
import PropTypes from 'prop-types';
import VideoUploadFieldset from './videoUploadFieldset';

const VideoUpload = props => {
  let thankYouForCommentVideo;

  if (
    props.translations['thank-you-for-comment-video'] &&
    props.comment.user &&
    props.comment.user.firstName
  ) {
    thankYouForCommentVideo = props.translations[
      'thank-you-for-comment-video'
    ].replace('%{name}', props.comment.user.firstName);
  }

  return (
    <section className="site-width">
      <form>
        <h3>{thankYouForCommentVideo}</h3>
        <p>{props.translations['please-select-video']}</p>
        <p>{props.translations['video-hint']}</p>
        {props.videoUploadSuccessful ? (
          <h3>{props.translations['file-uploaded']}</h3>
        ) : (
          <VideoUploadFieldset {...props} />
        )}
      </form>
    </section>
  );
};

VideoUpload.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  comment: PropTypes.shape({
    user: PropTypes.shape({
      firstName: PropTypes.string,
    }),
  }).isRequired,
  submitVideo: PropTypes.func,
  videoUploadSuccessful: PropTypes.bool.isRequired,
  error: PropTypes.string,
  videoFileName: PropTypes.string,
  captureFileName: PropTypes.func,
  spinnerDisplay: PropTypes.bool,
};

VideoUpload.defaultProps = {
  submitVideo: () => {},
  error: '',
  videoFileName: '',
  captureFileName: () => {},
  spinnerDisplay: false,
};

export default VideoUpload;
